import { Content } from 'src/contexts/ContentContext';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { ContentId } from 'src/utils/constants/contentId';
import { Feature } from 'src/WebApiController';

import { useAlertWithSuppressionDialog } from './useAlertWithSuppressionDialog';
import { useEventConfirmationDialogSuppressionTimestamp } from './useEventConfirmationDialogSuppressionTimestamp';

export function useManualPriceAdjustFloorOrCeilingDialog(
  listPrice: number | null,
  netProceedsFloor: number | null | undefined,
  netProceedsCeiling: number | null,
  onOkay: () => void,
  onCancel: () => void,
  viagogoVirtualId?: string | null
) {
  const { value, ...rest } = useAlertWithSuppressionDialog(
    'manualPriceAdjustFloorOrCeilingTimestamp',
    onOkay,
    onCancel
  );

  const hasSellerEventAlertMutesFeature = useUserHasFeature(
    Feature.SellerEventAlertMutes
  );

  const eventLastTimeStamp = useEventConfirmationDialogSuppressionTimestamp(
    'manualPriceAdjustFloorOrCeilingTimestamp',
    viagogoVirtualId
  );

  const lastTimeStamp =
    hasSellerEventAlertMutesFeature && viagogoVirtualId
      ? eventLastTimeStamp
      : value?.manualPriceAdjustFloorOrCeilingTimestamp;

  return {
    ...rest,
    lastTimeStamp,
    bodyText: (
      <Content
        id={
          (listPrice ?? 0) < (netProceedsFloor ?? Number.MIN_VALUE)
            ? ContentId.ManualPriceAdjustFloorWarning
            : (listPrice ?? 0) > (netProceedsCeiling ?? Number.MAX_VALUE)
              ? ContentId.ManualPriceAdjustCeilingWarning
              : ContentId.EmptyContent
        }
      />
    ),
  };
}
